import { css, Global } from "@emotion/react";

const globalStyles = css`
  .ant-drawer .ant-drawer-close:hover {
    background-color: rgba(0, 0, 0, 0) !important;
    cursor: pointer !important;
  }
  .ant-drawer .ant-drawer-header {
    border-bottom: none !important;
  }

  .ant-drawer .ant-drawer-body {
    padding: 0px 0px 0px 0px;
  }
  .ant-drawer .ant-drawer-title {
    flex: 1;
    margin: 0;
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
    font-size: 22px;
    line-height: 1.5;
    font-weight: bold;
  }

  .css-15v22id-MuiAccordionDetails-root {
    padding: 0px 16px 16px !important;
  }
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
};

export default SC;
